import { Link } from 'react-router-dom';
import Routes from '../../../../constants/routes';
import { world } from '../../../../languages';
import { CONFIG } from './twenty-five-euro-incentive.constants';
import './twenty-five-euro-incentive.scss';

const TwentyFiveEuroIncentive = () => {
    return (
        <Link to={Routes.SELLER.path}>
            <div className='twenty-five-euro-incentive d-flex align-items-center justify-content-center'>
                <img alt='' className='mr-1' height={42} src={CONFIG[world].imgLeft} />
                <b style={{ fontSize: 18 }}>{CONFIG[world].text()}</b>
                <img alt='' className='ml-1' height={42} src={CONFIG[world].imgRight} />
            </div>
        </Link>
    );
};

export default TwentyFiveEuroIncentive;
